import React, { useId } from 'react';

import { Heading } from '@rover/kibble/core';
import BottomSheet from '@rover/kibble/official-patterns/BottomSheet';
import Modal from '@rover/kibble/official-patterns/Modal';
import MQ from '@rover/kibble/styles/MediaQuery';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';

export type ResponsiveOverlayProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  title: string;
  children: React.ReactNode;
};

const ResponsiveOverlay: React.FC<ResponsiveOverlayProps> = ({
  isOpen,
  onRequestClose,
  title,
  children,
}) => {
  const headerId = useId();
  const isMobile = useMatchMedia(MQ.XS.getBreakpointString());

  if (isMobile) {
    return (
      <BottomSheet
        showCloseIcon={false}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        headerId={headerId}
      >
        <Heading id={headerId} size="300" mb="4x">
          {title}
        </Heading>
        {children}
      </BottomSheet>
    );
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} headerText={title}>
      {children}
    </Modal>
  );
};

export default ResponsiveOverlay;
